// Module
var code = "<a class=\"ccs-link table-svg-holder shared-icon\" ng-include=\"'assets/html-based-icons/share-icon.html'\" uib-popover-template=\"'app/views/common/copy_popover.html'\" popover-placement=\"left\"> </a> ";
// Exports
module.exports = code;